import Util from './Util';

export default class EnvUtil extends Util {
  static isProd() {
    return process.env.REACT_APP_MODE === 'prod' || process.env.REACT_APP_MODE === 'production';
  }

  static sentryDns() {
    return process.env.REACT_APP_SENTRY_DNS;
  }

  static isLocal() {
    return process.env.REACT_APP_MODE && process.env.REACT_APP_MODE === 'local';
  }
}
